export const campaignKeys = {
  all: ['campaigns'] as const,
  detail: (practiceId: string, campaignId: string) =>
    ['campaigns', practiceId, campaignId] as const,
  searchTerms: (campaignId: string) => ['campaign-search-terms', campaignId] as const,
  heatmap: (campaignId: string) => ['campaign-heatmap', campaignId] as const,
  insights: (campaignId: string) => ['campaign-insights', campaignId] as const,
  recs: (campaignId: string) => ['campaign-recs', campaignId] as const,
  locationRecs: () => ['location-campaign-recs'] as const,
  marketing: () => ['marketing-campaigns'] as const,
  marketingByLocation: (locationId: string) => ['marketing-campaigns', locationId] as const,
  locationAdsConfig: (locationId: string) => ['location-ads-config', locationId] as const,
};

export const adsKeys = {
  campaigns: (locationId: string, range: string) =>
    ['ads', 'campaigns', locationId, range] as const,
  audit: (locationId: string) => ['ads', 'audit', locationId] as const,
  auditAll: () => ['ads', 'audit'] as const,
  trend: (id: string, range: string) => ['ads', 'trend', id, range] as const,
  weeklySummary: (locationId: string) => ['ads', 'weekly-summary', locationId] as const,
  metrics: (locationId: string, range: string) =>
    ['ads', 'metrics', locationId, range] as const,
  recommendations: (locationId: string) => ['ads', 'recommendations', locationId] as const,
};

export const activityKeys = {
  ads: (locationId: string) => ['activity', 'ads', locationId] as const,
  recap: (locationId: string, range: string) => ['activity', 'recap', locationId, range] as const,
};

export const performanceKeys = {
  summary: (locationId: string, range: string) =>
    ['campaigns', 'performance', 'summary', locationId, range] as const,
  channels: (locationId: string, range: string) =>
    ['campaigns', 'performance', 'channels', locationId, range] as const,
  campaigns: (locationId: string, range: string) =>
    ['campaigns', 'performance', 'campaigns', locationId, range] as const,
  searchTerms: (locationId: string, range: string) =>
    ['campaigns', 'performance', 'search-terms', locationId, range] as const,
  heatmap: (locationId: string, range: string) =>
    ['campaigns', 'performance', 'heatmap', locationId, range] as const,
};
